import { render, staticRenderFns } from "./provLogoAdd.vue?vue&type=template&id=753acc86&scoped=true"
import script from "./provLogoAdd.vue?vue&type=script&lang=js"
export * from "./provLogoAdd.vue?vue&type=script&lang=js"
import style0 from "./provLogoAdd.vue?vue&type=style&index=0&id=753acc86&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753acc86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753acc86')) {
      api.createRecord('753acc86', component.options)
    } else {
      api.reload('753acc86', component.options)
    }
    module.hot.accept("./provLogoAdd.vue?vue&type=template&id=753acc86&scoped=true", function () {
      api.rerender('753acc86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/logoSet/provLogoAdd.vue"
export default component.exports